<template>
  <div class="second-step-to-self">
    <div class="tips-card">
      <div class="subtitle">{{$t('Precautions')}}</div>
      <p class="tips-p"
         v-for="(item,index) in descs"
         :key="index"
      >{{item}}</p>
    </div>
    <div class="bgc-bar"></div>
    <el-form
      class="to-self"
      ref="form"
      :model="form"
      :rules="rules"
    >
      <!--    :label="$t('Accounts_receivable')" prop="login"-->
      <el-form-item
      >
        <div class="self-label" slot="label">
          {{$t('Payee')}}
        </div>
        <mtaccount-list
          ref="toaccount"
          :is-dialog-inner="isDialogInner"
        ></mtaccount-list>
      </el-form-item>
      <el-form-item
        class="desc-item"
      >
        <div class="nav-title">{{$t('Commission_can_be_withdrawn')}}</div>
        <p class="balance">${{remainAmount || 0}}</p>
      </el-form-item>
      <el-form-item
        :label="$t('User.transAmount')"
        prop="amount"
        class="has-prefix-item"
      >
        <el-input
          :placeholder="$t('please_input')"
          v-model="form.amount"
          @input="inputHandle"
        >
          <span slot="prefix">$</span>
        </el-input>
      </el-form-item>
    </el-form>
  </div>

</template>

<script>
import mtaccountList from "@/components/public/mtaccountList";
import { mapGetters } from 'vuex'
import {amountInputValidate, onlyTwoBitFloat} from "@/utils/validate";
export default {
  name: "secondStepSelfAccount",
  components: {
    mtaccountList
  },
  props: {
    descs:{

    },
    remainAmount: {
    }
  },
  data() {
    let _this = this;
    var validateMoney = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(_this.$t('payChannel.inputMoney')));
      }else {
        if(!onlyTwoBitFloat(value)){
          callback(new Error(_this.$t('User.onlyInputTwoBitNumber')));
          _this.$emit('request-err');
          return;
        }else {
          if(+value > _this.remainAmount){
            callback(new Error(_this.$t('The_commission_cannot_be_exceeded')));
          }else {
            callback();
          }
        }
      }
    };
    return {
      isDialogInner: true,

      form: {
        login: '',
        amount: ''
      },
      rules: {
        login: [
          { required: true, message: _this.$t('please_choose'), trigger: 'blur' },
        ],
        amount: [
          { required: true, message: _this.$t('please_input'), trigger: 'blur' },
          { validator: validateMoney, trigger: 'blur' },
        ]
      },
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  watch: {
  },
  created(){
  },
  methods: {
    getLabel(item){
      return `MT4 (${item.login}) $${this.$t('balance')}: ${item.balance}`;
    },
    inputHandle(val){
      this.form.amount = amountInputValidate(val);
    },
    validate(){
      if(!(+this.remainAmount)){
        this.$message({
          message: this.$t('The_amount_that_can_be_withdrawn_is_0'),
          type: 'warning'
        });
        return;
      }
      if(!this.$refs.toaccount.curLogin){
        this.$message({
          type: 'waring',
          message: this.$t('Please_select_the_payment_account')
        });
        return;
      }
      this.$refs.form.validate((valid) => {
        if(valid){

          this.$emit('validate-form-flag',this.form,this.$refs.toaccount.curLogin);
        }else {
          console.log('error');
        }
      });
    },
    interfaceAjaxSuccess(){
      this.$emit('ajax-success');
    },
  },
}
</script>

<style lang="scss" scoped>
.second-step-to-self {
  .tips-card {
    padding-top: 10px;
    padding-bottom: 15px;
    .tips-p {
      color: #5E5873;
    }
  }
  .bgc-bar {
    width: 360px;
    position: relative;
    left: -1.5rem;
    height: 12px;
    background-color: #F8F8F8;
  }
}

.to-self {
  .self-label {
    &::before {
       content: '*';
      color: #F56C6C;
      padding-right: 2px;
    }
  }
  .has-prefix-item {
    /deep/ .el-input__prefix {
      left: 15px;
    }
  }
  .nav-title,
  .balance {
    line-height: 20px;
  }
  /deep/ .desc-item {
    margin-bottom: 15px;
  }
}
.self-mtlist-select {
  height: 86px;
  .inner-bot {
    padding-left: 34px;
  }
  .account-top {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .icon-el {
      width: 24px;
      height: 24px;
    }
    .login {
      padding-left: 10px;
      font-weight: 600;
      font-size: 14px;
    }

  }
}
.subtitle {
  font-size: 16px;
  font-weight: 600;
  color: #5E5873;
  margin-bottom: 10px;
}
</style>
